ixModuleRouting("impactx.orderconfiguration", {
    "/orderconfigurationlist": {
        template: "<ixa-orderconfiguration-list></ixa-orderconfiguration-list>",
        process: "OrderConfiguration",
        workspace: "content",
    },
    "/orderconfiguration/:id": {
        template: "<ixa-orderconfiguration></ixa-orderconfiguration>",
        templateUrl: "modules/orderconfiguration/templates/orderconfiguration.html",
        controller: "OrderConfigurationCtrl",
        controllerAs: "orderConfigurationCtrl",
        process: "OrderConfiguration",
        workspace: "content",
    },
    "/orderconfiguration/new/:id": {
        template: "<ixa-orderconfiguration></ixa-orderconfiguration>",
        templateUrl:
            "modules/orderconfiguration/templates/orderconfiguration.html",
        controller: "OrderConfigurationCtrl",
        controllerAs: "orderConfigurationCtrl",
        process: "OrderConfiguration",
        workspace: "content",
    },
});
